import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {DEFAULT_MESSAGE} from "appConstants";
import {AxiosError} from "axios";
import {GenAIService} from "services/GenAIService";
import {OwnerSummaryAttributes} from "typing/dto";

// Service Singletons
const genAIService = GenAIService.getInstance();

export const fetchSummary = createAsyncThunk<OwnerSummaryAttributes | null, number, {rejectValue: string}>(
    "ticketOwnerSummary/fetchSummary",
    async (unitId: number, {rejectWithValue}) => {
        try {
            const response = await genAIService.getOwnerSummaryByUnitId(unitId);
            return response;
        } catch (e) {
            return rejectWithValue((e as AxiosError<{error: string}>)?.response?.data?.error || DEFAULT_MESSAGE.ERROR);
        }
    }
);

export interface ITicketSummaryState {
    error: string;
    isLoadingFetch: boolean;
    summary: OwnerSummaryAttributes | null;
}

export const initialState: ITicketSummaryState = {
    isLoadingFetch: false,
    summary: null,
    error: "",
};

const ticketOwnerSummarySlice = createSlice({
    name: "ticketOwnerSummary",
    initialState,
    reducers: {
        setError: (state: ITicketSummaryState, {payload}) => {
            state.error = payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchSummary.pending, (state: ITicketSummaryState) => {
                state.isLoadingFetch = true;
                state.summary = null;
                state.error = "";
            })
            .addCase(fetchSummary.fulfilled, (state: ITicketSummaryState, {payload}) => {
                state.isLoadingFetch = false;
                state.summary = payload as OwnerSummaryAttributes;
            })
            .addCase(fetchSummary.rejected, (state, {payload}: {payload: any}) => {
                state.isLoadingFetch = false;
                state.error = payload;
            });
    },
});

export const {setError} = ticketOwnerSummarySlice.actions;

export default ticketOwnerSummarySlice.reducer;
